/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { assetListingBatchesApiUrls } from '@/configs/api-urls/asset-listing-batches.api-urls'
import { assetsBatchesApiUrls } from '@/configs/api-urls/assets-batches.api-urls'
import { samsBuildBatchesApiUrls } from '@/configs/api-urls/sams-build-batches'
import {
  LISTING_BATCH_LABEL_FILTER_LABEL,
  REGISTRATION_BATCH_FILTER_LABEL,
  SAM_BUILDING_BATCH_FILTER_LABEL
} from '@/configs/strings/items-labels'
import {
  getDefaultSortOptions,
  pickDefaultFilterOptions
} from '@/utils/cards.utils'

export const sortOptions = getDefaultSortOptions()

export const filterOptions = [
  ...pickDefaultFilterOptions(['title', 'creator', 'publisher', 'fileType']),
  {
    id: 'registrationBatchName',
    label: REGISTRATION_BATCH_FILTER_LABEL,
    type: 'autocomplete',
    api: (inputValue) => `${assetsBatchesApiUrls.search}?name=${inputValue}`,
    searchResultsKeyData: 'data',
    searchResultsKeyLabel: 'name',
    searchResultsKeyValue: 'name'
  },
  {
    id: 'listingBatchName',
    label: LISTING_BATCH_LABEL_FILTER_LABEL,
    type: 'autocomplete',
    api: (inputValue) => `${assetListingBatchesApiUrls.search}?name=${inputValue}`,
    searchResultsKeyData: 'data',
    searchResultsKeyLabel: 'name',
    searchResultsKeyValue: 'name'
  },
  {
    id: 'samBuildingBatchName',
    label: SAM_BUILDING_BATCH_FILTER_LABEL,
    type: 'autocomplete',
    api: (inputValue) => `${samsBuildBatchesApiUrls.search}?name=${inputValue}`,
    searchResultsKeyData: 'data',
    searchResultsKeyLabel: 'name',
    searchResultsKeyValue: 'name'
  },
  ...pickDefaultFilterOptions(['assetId'])
]
